import React from 'react';

import { deviceBattery } from '../../services/DeviceUtils';

const ranges = [
  { start: 0, end: 5, value: 0 }, // 0%
  { start: 5, end: 35, value: 1 }, // 25%
  { start: 35, end: 60, value: 2 }, // 50%
  { start: 60, end: 85, value: 3 }, // 75%
  { start: 85, end: 101, value: 4 }, // 100%
];

export const DeviceBatteryIndicator = ({ device }: { device?: Device }) => {
  const battery = deviceBattery(device);

  let batteryNormalized = battery || 0;
  if (!batteryNormalized || batteryNormalized < 0) {
    batteryNormalized = 0;
  }
  if (batteryNormalized > 100) {
    batteryNormalized = 100;
  }

  const batteryLevel = (ranges.find(def => batteryNormalized >= def.start && batteryNormalized < def.end) || { value: 0 }).value;

  return (
    <>
      <span style={{ marginRight: '10px' }}>
        <i className={`shieldgps-icon icon-battery-${batteryLevel}`}></i>
      </span>
      {batteryNormalized.toFixed(0)}%
    </>
  );
}